import * as tf from "@tensorflow/tfjs-core";

const BACKEND_FLAGS_MAP = {
  ['tfjs-wasm']: ['WASM_HAS_SIMD_SUPPORT', 'WASM_HAS_MULTITHREAD_SUPPORT'],
  ['tfjs-webgl']: [
    'WEBGL_VERSION', 'WEBGL_CPU_FORWARD', 'WEBGL_PACK',
    'WEBGL_FORCE_F16_TEXTURES', 'WEBGL_RENDER_FLOAT32_CAPABLE',
    'WEBGL_FLUSH_THRESHOLD'
  ],
  ['mediapipe-gpu']: []
};

export class TensorFlowEnv {
  static async setEnv() {
    const flags = {}
    const backend = 'mediapipe-gpu';
    const TUNABLE_FLAG_DEFAULT_VALUE_MAP = {};
    for (const backend in BACKEND_FLAGS_MAP) {
      for (let index = 0; index < BACKEND_FLAGS_MAP[backend].length; index++) {
        const flag = BACKEND_FLAGS_MAP[backend][index];
        TUNABLE_FLAG_DEFAULT_VALUE_MAP[flag] = await tf.env().getAsync(flag);
      }
    }

    for (const flag in TUNABLE_FLAG_DEFAULT_VALUE_MAP) {
      if (BACKEND_FLAGS_MAP[backend].indexOf(flag) > -1) {
        flags[flag] = TUNABLE_FLAG_DEFAULT_VALUE_MAP[flag];
      }
    }
    await this.setBackendAndEnvFlags(flags, backend)
  }

  static async setBackendAndEnvFlags(flagConfig, backend) {
    tf.env().setFlags(flagConfig);

    const [runtime, $backend] = backend.split('-');

    if (runtime === 'tfjs') {
      await this.resetBackend($backend);
    }
  }

  static async resetBackend(backendName) {
    const ENGINE = tf.engine();
    if (!(backendName in ENGINE.registryFactory)) {
      throw new Error(`${backendName} backend is not registed.`);
    }

    if (backendName in ENGINE.registry) {
      const backendFactory = tf.findBackendFactory(backendName);
      tf.removeBackend(backendName);
      tf.registerBackend(backendName, backendFactory);
    }

    await tf.setBackend(backendName);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/TensorFlowEnv.js